
import { Vue, Component } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import Notifications from "./views/notifications/Notifications.vue";
import TrainingVideos from './views/shared/TrainingVideos.vue';
import { namespace } from "vuex-class";
//import * as signalR from "@microsoft/signalr";
//import bus from '../src/eventBus'
import { useAppInsights } from './store/modules/AppInsights'
import { bus } from "./main";
import { sortAscByKey } from '@/utils/utils';
import VueMultiselect from 'vue-multiselect';


const dotenv = require("dotenv");

const profile = namespace("profile");
@Component({
    components: { Notifications, TrainingVideos, VueMultiselect },
    data() {
        return {
            value: '' as any,
            listofTenants: '' as any
        }
    },
    updated() {
        if (this.profileData.tenantId !== undefined) {
            this.value = this.$store.state.profile.profileData.tenants.find(x => x.tenantId == this.profileData.tenantId)
            this.listofTenants = this.profileData.tenants
        }
    },
    methods: {
        async setTenantDataToSession(event: any) {
            sessionStorage["tenant"] = event.tenantId;
            var sessionTenantID;
            if (sessionStorage.getItem("tenant") != null) {
                sessionTenantID = sessionStorage.getItem("tenant");
                await this.$store.dispatch("profile/getProfileDetails", '')
            }
            if (event.isAdmin === true && event.staffId === 0) {
                const path = '/admin'
                if (this.$route.path !== path) {
                    this.$router.push('/admin')
                }
            }
            else {
                const path = '/schedule'
                if (this.$route.path !== path) {
                    this.$router.push('/schedule')
                }
            }
        }
    }
    ,
    computed: {
        ...mapGetters(["profileData"]),
        ...mapGetters(["oidcUser"]),
        tenants() {
            const values = sortAscByKey(this.profileData.tenants, 'tenantName');
            return (values || []).map(v => ({
                ...v,
                text: v.tenantName,
                value: v.tenantId
            })) as any
        },
        selectedTenant: {
            // getter 
            get: function () {
                var selected = this.tenants.find(x => x.tenantId == this.profileData.tenantId)
                return selected;
            },
            // setter 
            set: function (newVal) {
                this.value = newVal
            }
        }
    },
})
export default class App extends Vue {
    appVersion: string = "";
    notificationView: boolean = false;
    oidcUser!: any;
    @profile.State
    profileData!: any;
    @profile.State
    isAdmin!: boolean;
    @profile.State
    isImpersonating!: boolean;
    showNavigation: boolean = false;
    updatedunreadCount: number = 0;
    @profile.State
    appInsightEventData!: any;
    //Signal R
    token = localStorage.getItem("token");
    logoutUrl: any = `${process.env.VUE_APP_AUTHORITY}/SSOLogout/logout.jsp`;

    // connection = new signalR.HubConnectionBuilder()
    //     .withUrl(process.env.VUE_APP_SIGNALR_HUB_URL!, {
    //         accessTokenFactory: () => this.token!,
    //     })
    //     .withAutomaticReconnect([2000])
    //     .configureLogging(signalR.LogLevel.Information)
    //     .build();

    constructor() {
        super();

        //subscribe event to get signal r notification
        // this.connection.on("notificationRecieved", (message: string) => {
        //     bus.$emit("assignmentchanged", "Hello");
        // });

        // this.connection.on("messagereceived", (msgEvent: any) => {
        //     if (msgEvent.type == 1) {
        //         bus.$emit("assignmentchanged", msgEvent.message);
        //     }
        //     else if (msgEvent.type == 2) {
        //         bus.$emit("smsprefchanged", msgEvent.message);
        //     }
        //     else if (msgEvent.type == 3) {
        //         bus.$emit("notificationchanged", msgEvent.message);
        //     }
        // });

        //start signal r connection
        //this.connection.start().catch((err) => console.log(err));
        this.appVersion = process.env.VUE_APP_PORTALVER!;
        localStorage.setItem("isUserLoggedIn", 'true');
    }

    isSelected(route: string) {
        return this.$route.path.includes(route);
    }

    toggleNavigationPanel() {
        this.showNavigation = !this.showNavigation;
    }

    toggleNotificationPanel() {
        this.notificationView = !this.notificationView;
    }

    notificationCountUpdate(unreadCount: any) {
        this.updatedunreadCount = unreadCount.count;
    }
    NavigateToFS() {
        useAppInsights().trackEvent({
            name: 'UserNavigatedToFS', properties:
                this.appInsightEventData
        });
    }
}
